import React from 'react'

const CustomerCookiesPolicy = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        Cookies Policy
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <div>
                        <>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, we believe in being clear and open about how we collect and use data related to you. This policy provides detailed information about how and when we use cookies and similar technologies on our website and mobile application.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>1. What are Cookies?</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At its simplest, a cookie is a tiny data file stored on your device. When you use Maidly, our servers send these files to your phone or computer to create a seamless, personalized experience. Without cookies, every time you clicked a new page, the app would treat you like a complete stranger.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. How They Work on Maidly</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>When you interact with our platform, cookies act like a digital "ID Badge."</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Recognition:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}They tell us, "This is the same user who just added a 'Kitchen Deep Clean' to their cart."</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Persistence:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}They allow the app to remember that you’ve already logged in, so you aren’t prompted for your password every 30 seconds.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. The Two Main Types We Use</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Session Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These are short-term helpers. They live only as long as your "session" (the time you spend on the app). Once you close the Maidly app or your browser, these cookies are automatically deleted. They are primarily used to keep track of your progress while you are actively booking a service.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Persistent Cookies (Long-term):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These stay on your device for a set period (or until you manually delete them). These are what allow us to remember your Preferred Address or your Favorite Cook even if you don't visit the app for two weeks.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Cookies vs. Mobile Identifiers</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Since many of our customers use the Maidly Mobile App, we also use "Mobile Identifiers".</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>While not exactly "cookies," they perform the same job: they help us recognize your specific device so we can send you relevant Push Notifications and ensure your app settings remain exactly how you left them.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>D. First-Party vs. Third-Party Cookies</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>First-Party Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These are set directly by Maidly. We use these for core functions like security and account management.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Third-Party Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These are set by our trusted partners. For example, Google Maps uses a cookie to show you the real-time location of your professional, and Razorpay uses them to ensure your payment is processed securely.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>Types of Cookies We Use</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Strictly Necessary Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Required for login, booking, payment, and security. These cannot be disabled.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Analytics Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Help us improve performance and user experience.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Marketing Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Used to show relevant ads and promotions.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Functional Cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Remember preferences like saved addresses and favorite professionals.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2. How Maidly Uses Cookies</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We use cookies and tracking technologies to make your journey from "messy house" to "clean home" as frictionless as possible. Here is a breakdown of the four ways Maidly utilizes this data:</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Keeping You Logged In (Authentication)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>The most vital use of cookies is ensuring you don’t have to re-enter your mobile number and OTP every time you open the app.</span>
                            </p>
                            <p>
                                <strong>The Benefit:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}Once you log in, a persistent cookie tells our server that your session is authorized. This allows you to browse different cleaning packages and book a pro instantly.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>B. Remembering Your Favorites (Personalization)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly learns your preferences over time to save you clicks.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Saved Locations:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Cookies store your primary service address (Home, Office, or Parents' House) so you don't have to use GPS or type it out every time.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Preferred Pros:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you’ve rated a specific cook or plumber 5 stars, cookies help us prioritize showing you their availability first the next time you open the app.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Smart Scheduling:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you usually book a cleaning every Friday at 10:00 AM, cookies help our "Smart Suggest" feature remind you at the right time.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Security &amp; Fraud Prevention</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We use cookies as a layer of defense for your account and your home.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Bot Detection:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Cookies help us distinguish between a real human booking a maid and a malicious "bot" trying to spam our system.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Payment Safety:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}During the checkout process, cookies work with our payment partners to ensure the transaction is coming from your recognized device, reducing the risk of credit card fraud.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Improving Our Service (Performance &amp; Analytics)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We want to know what works and what doesn't.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Feature Tracking:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use analytics cookies to see if users are finding the new "Pet-Friendly Cleaning" toggle or if they are getting stuck on the payment page.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Load Balancing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}These cookies help us manage our server traffic, ensuring that the Maidly app stays fast and responsive even during high-demand periods.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Relevant Promotions (Marketing)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We hate spam as much as you do. Cookies help us ensure that the ads or notifications you see are actually relevant.</span>
                            </p>
                            <p>
                                <strong>Example:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}If you’ve been looking at "Deep Cleaning" services, we use cookies to show you a discount code for that specific service, rather than showing you an ad for "Electrical Repairs" which you don't need.</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>When you first visit our website, you will be presented with a cookie banner allowing you to accept or manage non-essential cookies.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>3. Third-Party Cookies</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>While some cookies are served directly by Maidly, others are set by our partners to provide specialized features that we don't build ourselves. These are called "Third-Party Cookies." We only allow trusted companies to place cookies on your device through our platform.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Navigation &amp; Location Services (Google Maps)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Because Maidly involves sending a professional to your doorstep, we use Google Maps to facilitate location tracking.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Cookie’s Job:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}It allows you to "pin" your exact location and lets you see the real-time movement of your pro (e.g., "Your plumber is 2km away").</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Data Collected:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Anonymous location data and map interactions.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Secure Payment Processing (Razorpay / Stripe)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Safety is paramount when handling your money. Our payment gateway partners set cookies to ensure transactions are processed without errors.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Cookie’s Job:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To verify that the payment is being made by a legitimate user and to prevent "session hijacking" or fraudulent card use.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Data Collected:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Device fingerprinting and encrypted transaction tokens.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Communication &amp; Support</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We want to be available if you have a problem. Third-party cookies power our "Live Chat" feature.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Cookie’s Job:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To remember your previous conversations with our support team so you don't have to explain your problem twice.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Data Collected:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Support history and browser type.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Performance &amp; Analytics (Google Analytics / Mixpanel)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>To make Maidly better, we need to see the "big picture" of how people use the app.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Cookie’s Job:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}It tracks anonymous patterns—like which city is booking the most "Maids" or which time of day the app is busiest.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Data Collected:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Time spent on pages, button clicks, and device type. Crucially, these are aggregated and do not identify you personally.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Marketing &amp; Advertising (Meta / Google Ads)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If you see an ad for a Maidly discount while browsing Facebook or Instagram, it’s because of a third-party marketing cookie (often called a "Pixel").</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>The Cookie’s Job:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To show you relevant offers based on your interest in Maidly services.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Data Collected:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}The fact that you visited the Maidly app/site and which services you viewed.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>4. Your Choices &amp; Controls</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>At Maidly, we believe you should have total control over your digital footprint. While some cookies are necessary for the app to function, you have several ways to manage or limit how tracking technologies are used.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Browser-Level Controls (Web Users)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If you access Maidly through a web browser (Chrome, Safari, Firefox), you can modify your settings to:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Accept or Reject:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Choose to block all cookies or only third-party cookies.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Clear History:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Delete all existing cookies stored on your device at the end of your session.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>"Do Not Track" (DNT):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can enable DNT in your browser settings; however, please note that there is currently no industry-wide standard for how DNT signals are handled.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Mobile App Settings (iOS &amp; Android Users)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Mobile devices don't use traditional cookies in the same way browsers do, but they use unique advertising identifiers.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>iOS (Apple):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Go to Settings &gt; Privacy &amp; Security &gt; Tracking to see which apps have permission to track you and toggle them off.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Android (Google):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Go to Settings &gt; Google &gt; Ads and select "Delete Advertising ID" or "Opt out of Interest-Based Ads."</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Maidly In-App Preferences</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Within the Maidly App, we provide specific toggles to give you more granular control:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Marketing Permissions:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Under Profile &gt; Settings &gt; Notifications, you can opt out of receiving "Promotional Offers" and "Discount Alerts" that are powered by tracking data.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Location Services:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can choose to allow Maidly to access your location "Only while using the app." This ensures we only track your GPS when it’s necessary for a booking.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Third-Party Opt-Out Tools</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Many of our partners allow you to opt out of their tracking directly:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Google Analytics:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can install the Google Analytics Opt-out Add-on.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Facebook (Meta):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can adjust your Ad Preferences to control what data Meta uses to show you Maidly ads.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>5. The Consequences of Disabling Cookies</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Choosing to disable or delete cookies is your right, but because Maidly is a real-time service platform, doing so may limit certain features and functionalities of the platform. Here is exactly what happens if you choose to browse or book without them:</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Loss of Convenience (The "Memory" Gap)</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Repeated Logins:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Without authentication cookies, Maidly cannot remember that you have already logged in. You will likely be asked to verify your identity via OTP or password every time you navigate to a new screen or refresh the page.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Manual Data Entry:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Your "Saved Addresses" (Home, Office, etc.) will disappear. You will have to manually type your full address and pinpoint your location on the map every single time you want to book a service.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Lost Cart Progress:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you start a booking for a "Full House Deep Clean" but get interrupted, your progress will not be saved. You’ll have to start the selection process from scratch when you return.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Performance &amp; Booking Accuracy</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Location Errors:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Since cookies help bridge your device's GPS and our server, disabling them may lead to the app showing you professionals who are not actually in your area, or worse, charging you incorrect "Out-of-Area" travel fees.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Partner Preferences:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Maidly will no longer be able to prioritize your "Favorite" professionals. If you have a specific maid or cook you love, you’ll have to search for them manually rather than having them suggested at the top of your list.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Security &amp; Payment Friction</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Verification Delays:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To protect against fraud, our payment gateways (like Razorpay) use cookies to recognize your device. Disabling them might trigger extra security layers, causing your bank to flag legitimate transactions as "Suspicious," leading to failed payments.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Bot Protection:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You may be frequently challenged by "CAPTCHA" tests (like selecting images of traffic lights) because our system can no longer use cookies to verify that you are a real human user.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Less Relevant Support &amp; Offers</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Support Amnesia:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you contact our help desk, our support tools use cookies to see your recent activity. Without them, our team won't know you just had a failed booking, and you’ll have to explain your issue from the very beginning.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Generic Content:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Instead of seeing a discount for the service you actually use (like a 10% off coupon for Plumbing), you will see generic advertisements that may not be relevant to your needs at all.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p>
                                <span style={{ fontWeight: 400 }}>We process data collected through cookies based on one or more of the following legal grounds:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Your consent (for marketing and analytics cookies)</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Performance of a contract (for essential service and authentication cookies)</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Legitimate interests (for security and fraud prevention)</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>Where required by applicable law, we will obtain your consent before placing non-essential cookies on your device.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>6. Updates to This Policy</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly may update this policy to reflect changes in technology or data laws. We will notify you of significant changes via in-app alerts or email. Continued use of the app after an update constitutes your acceptance of the new terms.</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We recommend that users review this policy periodically for updates.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>7. Contact Us</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>For any questions regarding this Cookies Policy, please reach out to:</span>
                            </p>
                            <p>
                                <strong>Email:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}support@redqubes.com</span>
                            </p>
                            <p>
                                <strong>Phone:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}+91 92576 52266</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Please include your Booking ID to help us process your request faster.</span>
                            </p>

                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerCookiesPolicy